<template>
    <div class="section pt-1 mt-2">
        <div class="wallet-card">
            <div class="wallet-footer">
                <ul class="nav nav-tabs lined" role="tablist">
                    <li class="nav-item">
                        <a class="nav-link mal-text" :class="{ active: current_tab === 'designation' }" data-bs-toggle="tab"
                            href="javascript:void(0)" role="tab" @click="current_tab = 'designation'">
                            {{$t('designation')}}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link mal-text" :class="{ active: current_tab === 'department' }" data-bs-toggle="tab"
                            href="javascript:void(0)" role="tab" @click="current_tab = 'department'">
                            {{$t('department')}}
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <div class="section mt-2" v-if="current_tab === 'designation'">
        <div class="transactions" v-if="designations.length">
            <div class="item" v-for="(d, index) in designations" :key="'d-' + index">
                <div class="detail">
                    <div>
                        <strong class="mal-text">{{ d.designation_label }}</strong>
                        <p class="mal-text">
                            {{ d.level_label }}<span v-if="d.org_unit_name"> · {{ d.org_unit_name }}</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="section mt-2 text-center" v-else>
            <p class="text-muted">No designations found.</p>
        </div>
    </div>

    <div class="section mt-2" v-if="current_tab === 'department'">
        <div class="transactions" v-if="departmentRows.length">
            <div class="item" v-for="(row, index) in departmentRows" :key="'p-' + index">
                <div class="detail">
                    <div>
                        <strong class="mal-text">{{ row.department }}</strong>
                        <p class="mal-text">
                            {{ row.level_label }}<span v-if="row.org_unit_name"> · {{ row.org_unit_name }}</span>
                            · {{ row.designation_label }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="section mt-2 text-center" v-else>
            <p class="text-muted">No departments found.</p>
        </div>
    </div>
</template>

<script>
import UserService from "../../services/user.service";

export default {
    name: "MyDesignations",
    data() {
        return {
            current_tab: "designation",
            designations: [],
        };
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        // One row per (designation, department) pair — a single position can carry more
        // than one department, so those need to fan out into separate rows here.
        departmentRows() {
            const rows = [];
            this.designations.forEach((d) => {
                (d.departments || []).forEach((dept) => {
                    rows.push({
                        department: dept,
                        level_label: d.level_label,
                        org_unit_name: d.org_unit_name,
                        designation_label: d.designation_label,
                    });
                });
            });
            return rows;
        },
    },
    mounted() {
        if (!this.currentUser) {
            location.replace("/");
        }
        this.$root.updateParent(this.$t('my_designations'));

        const cachedProfile = localStorage.getItem("my_profile");
        if (cachedProfile) {
            try {
                this.designations = JSON.parse(cachedProfile).designations || [];
            } catch (e) {
                this.designations = [];
            }
        }
        // Cache may be stale/absent (e.g. deep-linked here directly) — refresh from the
        // same endpoint MyProfile.vue uses either way.
        UserService.authPostRequest("get-my-profile", { user_id: this.currentUser.id }).then(
            (response) => {
                this.designations = response.data.data.list.designations || [];
            },
            () => {}
        );
    },
};
</script>
